import classnames from "classnames";
import { saveAs } from "file-saver";
import { useEffect, useState } from "react";
import { RiFileExcel2Line } from "react-icons/ri";
import Pagination from "react-js-pagination";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import Switch from "react-switch";
import {
  Button,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Spinner,
  TabContent,
  Table,
  TabPane,
} from "reactstrap";
import swal from "sweetalert";
import {
  applyClassToCharacters,
  isChildInHierarchy,
  LoadingSpinner,
} from "../../../../constants/const";
import { GetLanguageString, NoResult } from "../../../helper/Components";
import { GetCustomStyles, GetSelectedLanguage } from "../../../helper/Method";
import { ApiEvent } from "../../ApiEvent";
import SearchEventAttendeesList from "./SearchEventAttendeesList";
import { encryptStorage } from "../../../../constants/EncryptStorage";

const EventAttendeesList = ({
  eventId,
  eventUnitId,
  eventType,
  eventAddress,
  eventUnitType,
}) => {
  const selectedLanguage = GetSelectedLanguage();
  const unitTypeName = encryptStorage.getItem("unitTypeName");
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [loading, setLoading] = useState(false);
  const [searchButton, setSearchButton] = useState(false);
  const [apiCalled, setApiCalled] = useState(false);
  const [activeInnerTab, setActiveInnerTab] = useState("rufqa");
  const [memberList, setMemberList] = useState([]);
  const [ahbabList, setAhbabList] = useState([]);
  const [excelLoading, setExcelLoading] = useState(false);
  const [pagination, setPagination] = useState({ activePage: 1 });
  const [searchEventParticipants, setSearchEventParticipants] = useState({
    unit: {
      value: isChildInHierarchy(unitTypeName, eventUnitType)
        ? loggedInUnitId
        : eventUnitId,
      label: "",
    },
    unitId: isChildInHierarchy(unitTypeName, eventUnitType)
      ? loggedInUnitId
      : eventUnitId,
    eventId: eventId,
    isSubUnits: true,
    activePage: 1,
    pageSize: 10,
    attendanceStatus: null,
  });
  const toggleTab = (tab) => {
    if (activeInnerTab !== tab) setActiveInnerTab(tab);
  };
  const handlePageChange = (pageNumber) => {
    setSearchEventParticipants({
      ...searchEventParticipants,
      activePage: pageNumber,
    });
    setSearchButton(true);
  };
  useEffect(() => {
    if (searchButton) {
      setLoading(true);
      setApiCalled(true);
      ApiEvent()
        .GetEventAttendanceParticipantsReport(searchEventParticipants)
        .then((res) => {
          setPagination(res.data);
          setMemberList(res.data.rufqaList);
          setAhbabList(res.data.ahbabList);
          setLoading(false);
          setSearchButton(false);
        })
        .catch((err) => {
          swal({
            title: err,
            icon: "error",
            buttons: "OK",
          });
          setLoading(false);
          setSearchButton(false);
          setApiCalled(false);
        });
    }
  }, [searchEventParticipants, searchButton]);

  const excelDownload = () => {
    setExcelLoading(true);
    ApiEvent()
      .GetEventAttendanceParticipantsExcelReport(searchEventParticipants)
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(
          blob,
          `EventParticipantsList - ${eventType} - ${eventAddress}.xlsx`
        );
        setExcelLoading(false);
      })
      .catch((err) => {
        setExcelLoading(false);
        console.log(err);
      });
  };

  let recordIndex =
    searchEventParticipants.pageSize *
      (searchEventParticipants.activePage - 1) +
    1;

  let pageInfo = `Displaying ${recordIndex}-${
    recordIndex + pagination.pageSize - 1 < pagination.totalItemsRufqa
      ? recordIndex + pagination.pageSize - 1
      : pagination.totalItemsRufqa
  } of ${pagination.totalItemsRufqa}`;

  let recordIndexAhbab =
    searchEventParticipants.pageSize *
      (searchEventParticipants.activePage - 1) +
    1;

  let pageInfoAhbab = `Displaying ${recordIndexAhbab}-${
    recordIndexAhbab + pagination.pageSize - 1 < pagination.totalItemsAhbab
      ? recordIndex + pagination.pageSize - 1
      : pagination.totalItemsAhbab
  } of ${pagination.totalItemsAhbab}`;

  return (
    <>
      <div className="ibox">
        <div className="ibox-title">
          <h5>{<GetLanguageString props="common_search" />}</h5>
        </div>
        <SearchEventAttendeesList
          searchEventParticipants={searchEventParticipants}
          setSearchEventParticipants={setSearchEventParticipants}
          setSearchButton={setSearchButton}
        />
      </div>
      {apiCalled && (
        <div className="tabs-container">
          <div
            className="d-flex justify-content-between align-items-center flex-wrap"
            style={{
              borderBottom: "1px solid #dee2e6", // replicate Nav tabs border
              paddingLeft: 10,
              paddingRight: 10,
            }}
          >
            <Nav tabs className="mb-0">
              <NavItem>
                <NavLink
                  className={classnames({ active: activeInnerTab === "rufqa" })}
                  onClick={() => toggleTab("rufqa")}
                >
                  <GetLanguageString props="unit_non_responsible_member" />
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeInnerTab === "ahbab" })}
                  onClick={() => toggleTab("ahbab")}
                >
                  <GetLanguageString props="unit_ahbaab" />
                </NavLink>
              </NavItem>
            </Nav>

            <Button
              color="default"
              size="sm"
              onClick={excelDownload}
              className={GetCustomStyles().btn_style}
              style={{
                direction: GetSelectedLanguage() === "ur" ? "rtl" : "ltr",
                marginTop: -5,
              }}
            >
              {excelLoading ? (
                <Spinner size="sm" color="dark" />
              ) : (
                <>
                  <RiFileExcel2Line
                    size={15}
                    color="#009440"
                    style={{
                      marginRight: GetSelectedLanguage() === "ur" ? 0 : 3,
                      marginLeft: GetSelectedLanguage() === "ur" ? 3 : 0,
                      marginBottom: 1,
                    }}
                  />
                  <span style={{ color: "black" }}>
                    <GetLanguageString props="member_report_export_excel" />
                  </span>
                </>
              )}
            </Button>
          </div>

          <TabContent activeTab={activeInnerTab}>
            <TabPane tabId="rufqa">
              <div className="panel-body">
                {!loading ? (
                  memberList.length > 0 ? (
                    <div className="table-responsive">
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>{<GetLanguageString props="common_name" />}</th>
                            <th>
                              {<GetLanguageString props="member_reg_number" />}
                            </th>
                            <th className="text-center">
                              {
                                <GetLanguageString props="settings_member_type" />
                              }
                            </th>
                            <th className="text-center">
                              {<GetLanguageString props="unit_unit_table" />}
                            </th>
                            <th className="text-center">
                              {<GetLanguageString props="common_attendance" />}
                            </th>
                            <th>
                              {
                                <GetLanguageString props="events_participants_time_status" />
                              }
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {memberList?.map((record, index) => {
                            return (
                              <tr key={index}>
                                <td>{index + recordIndex}</td>
                                <td>
                                  <h4>
                                    {applyClassToCharacters(record.name, "ur")}
                                  </h4>
                                </td>
                                <td>{record.memberRegNo}</td>
                                <td className="text-center ur">
                                  {record.memberType}
                                </td>{" "}
                                <td className="ur">{record.memberUnitName}</td>
                                <td className="text-center">
                                  <Label
                                    className="form-check form-check-inline"
                                    for={"absentRafiq" + record.memberId}
                                  >
                                    <Input
                                      id={"absentRafiq" + record.memberId}
                                      type="radio"
                                      checked={record.attendanceStatus === 0}
                                      name={"status" + record.memberId}
                                      className="form-check-input"
                                      disabled
                                    />
                                    {
                                      <GetLanguageString props="events_participants_attendance_absent" />
                                    }
                                  </Label>
                                  <Label
                                    className="form-check form-check-inline"
                                    for={"presentRafiq" + record.memberId}
                                  >
                                    <Input
                                      id={"presentRafiq" + record.memberId}
                                      type="radio"
                                      checked={record.attendanceStatus === 1}
                                      name={"status" + record.memberId}
                                      className="form-check-input"
                                      disabled
                                    />
                                    {
                                      <GetLanguageString props="events_participants_attendance_present" />
                                    }
                                  </Label>
                                  <Label
                                    className="form-check form-check-inline"
                                    for={"leaveRafiq" + record.memberId}
                                  >
                                    <Input
                                      id={"leaveRafiq" + record.memberId}
                                      checked={record.attendanceStatus === 2}
                                      type="radio"
                                      name={"status" + record.memberId}
                                      className="form-check-input"
                                      disabled
                                    />
                                    {
                                      <GetLanguageString props="events_participants_attendance_leave" />
                                    }
                                  </Label>
                                </td>
                                <td>
                                  <Label
                                    htmlFor="small-radius-switch"
                                    for={"onTimeRafiq" + record.memberId}
                                  >
                                    <Switch
                                      id={
                                        "small-radius-switch onTimeRafiq" +
                                        record.memberId
                                      }
                                      disabled
                                      checked={record.onTime}
                                      handleDiameter={32}
                                      offColor="#888888"
                                      onColor="#6fcab8"
                                      offHandleColor="#fff"
                                      onHandleColor="#18A689"
                                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                      height={25}
                                      width={90}
                                      borderRadius={20}
                                      uncheckedIcon={
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "100%",
                                            color: "white",
                                            paddingRight: 25,
                                            fontSize:
                                              selectedLanguage === "ur"
                                                ? 25
                                                : 15,
                                            paddingBottom:
                                              selectedLanguage === "ur"
                                                ? 10
                                                : 0,
                                            fontWeight: "bold",
                                          }}
                                        >
                                          <GetLanguageString
                                            props={"events_participants_late"}
                                          />
                                        </div>
                                      }
                                      checkedIcon={
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "100%",
                                            width: "60px",
                                            color: "white",
                                            paddingLeft: 5,
                                            fontSize:
                                              selectedLanguage === "ur"
                                                ? 19
                                                : 12,
                                            paddingBottom:
                                              selectedLanguage === "ur" ? 5 : 0,
                                            fontWeight: "bold",
                                          }}
                                        >
                                          <GetLanguageString
                                            props={
                                              "events_participants_on_time"
                                            }
                                          />
                                        </div>
                                      }
                                      className="react-switch"
                                    />
                                  </Label>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                        <tr>
                          <td colSpan="2">{pageInfo}</td>
                          <td colSpan="11">
                            <ul className={GetCustomStyles().page_style}>
                              <Pagination
                                activePage={pagination.activePage}
                                itemsCountPerPage={pagination.pageSize}
                                totalItemsCount={pagination.totalItemsRufqa}
                                pageRangeDisplayed={pagination.pageRange}
                                onChange={handlePageChange}
                              />
                            </ul>
                          </td>
                        </tr>
                      </Table>
                    </div>
                  ) : (
                    <NoResult />
                  )
                ) : (
                  LoadingSpinner()
                )}
              </div>
            </TabPane>
            <TabPane tabId="ahbab">
              <div className="panel-body">
                {!loading ? (
                  ahbabList.length > 0 ? (
                    <div className="table-responsive">
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>{<GetLanguageString props="common_name" />}</th>
                            <th>
                              {<GetLanguageString props="member_reg_number" />}
                            </th>
                            <th className="text-center">
                              {
                                <GetLanguageString props="settings_member_type" />
                              }
                            </th>
                            <th className="text-center">
                              {<GetLanguageString props="unit_unit_table" />}
                            </th>
                            <th className="text-center">
                              {<GetLanguageString props="common_attendance" />}
                            </th>
                            <th>
                              {
                                <GetLanguageString props="events_participants_time_status" />
                              }
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ahbabList?.map((record, index) => {
                            let unitName = record.memberUnitName?.split("/");
                            return (
                              <tr key={index}>
                                <td>{index + recordIndex}</td>
                                <td>
                                  <h4>
                                    {applyClassToCharacters(record.name, "ur")}
                                  </h4>
                                </td>
                                <td>{record.memberRegNo}</td>
                                <td className="text-center ur">
                                  {record.memberType}
                                </td>{" "}
                                <td className="ur">
                                  <ol className="breadcrumb">
                                    {unitName.map((item, index) => {
                                      return (
                                        <li
                                          className={
                                            GetSelectedLanguage() === "ur"
                                              ? "breadcrumb-item-ur"
                                              : "breadcrumb-item"
                                          }
                                          key={index}
                                        >
                                          <Button
                                            size="xs"
                                            color="info"
                                            className="ur"
                                          >
                                            {item}
                                          </Button>
                                        </li>
                                      );
                                    })}
                                  </ol>
                                </td>
                                <td className="text-center">
                                  <Label
                                    className="form-check form-check-inline"
                                    for={"absentRafiq" + record.memberId}
                                  >
                                    <Input
                                      id={"absentRafiq" + record.memberId}
                                      type="radio"
                                      checked={record.attendanceStatus === 0}
                                      name={"status" + record.memberId}
                                      className="form-check-input"
                                      disabled
                                    />
                                    {
                                      <GetLanguageString props="events_participants_attendance_absent" />
                                    }
                                  </Label>
                                  <Label
                                    className="form-check form-check-inline"
                                    for={"presentRafiq" + record.memberId}
                                  >
                                    <Input
                                      id={"presentRafiq" + record.memberId}
                                      type="radio"
                                      checked={record.attendanceStatus === 1}
                                      name={"status" + record.memberId}
                                      className="form-check-input"
                                      disabled
                                    />
                                    {
                                      <GetLanguageString props="events_participants_attendance_present" />
                                    }
                                  </Label>
                                  <Label
                                    className="form-check form-check-inline"
                                    for={"leaveRafiq" + record.memberId}
                                  >
                                    <Input
                                      id={"leaveRafiq" + record.memberId}
                                      checked={record.attendanceStatus === 2}
                                      type="radio"
                                      name={"status" + record.memberId}
                                      className="form-check-input"
                                      disabled
                                    />
                                    {
                                      <GetLanguageString props="events_participants_attendance_leave" />
                                    }
                                  </Label>
                                </td>
                                <td>
                                  <Label
                                    htmlFor="small-radius-switch"
                                    for={"onTimeRafiq" + record.memberId}
                                  >
                                    <Switch
                                      id={
                                        "small-radius-switch onTimeRafiq" +
                                        record.memberId
                                      }
                                      disabled
                                      checked={record.onTime}
                                      handleDiameter={32}
                                      offColor="#888888"
                                      onColor="#6fcab8"
                                      offHandleColor="#fff"
                                      onHandleColor="#18A689"
                                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                      height={25}
                                      width={90}
                                      borderRadius={20}
                                      uncheckedIcon={
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "100%",
                                            color: "white",
                                            paddingRight: 25,
                                            fontSize:
                                              selectedLanguage === "ur"
                                                ? 25
                                                : 15,
                                            paddingBottom:
                                              selectedLanguage === "ur"
                                                ? 10
                                                : 0,
                                            fontWeight: "bold",
                                          }}
                                        >
                                          <GetLanguageString
                                            props={"events_participants_late"}
                                          />
                                        </div>
                                      }
                                      checkedIcon={
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "100%",
                                            width: "60px",
                                            color: "white",
                                            paddingLeft: 5,
                                            fontSize:
                                              selectedLanguage === "ur"
                                                ? 19
                                                : 12,
                                            paddingBottom:
                                              selectedLanguage === "ur" ? 5 : 0,
                                            fontWeight: "bold",
                                          }}
                                        >
                                          <GetLanguageString
                                            props={
                                              "events_participants_on_time"
                                            }
                                          />
                                        </div>
                                      }
                                      className="react-switch"
                                    />
                                  </Label>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                        <tr>
                          <td colSpan="2">{pageInfoAhbab}</td>
                          <td colSpan="11">
                            <ul className={GetCustomStyles().page_style}>
                              <Pagination
                                activePage={pagination.activePage}
                                itemsCountPerPage={pagination.pageSize}
                                totalItemsCount={pagination.totalItemsAhbab}
                                pageRangeDisplayed={pagination.pageRange}
                                onChange={handlePageChange}
                              />
                            </ul>
                          </td>
                        </tr>
                      </Table>
                    </div>
                  ) : (
                    <NoResult />
                  )
                ) : (
                  LoadingSpinner()
                )}
              </div>
            </TabPane>
          </TabContent>
        </div>
      )}
    </>
  );
};

export default withRouter(EventAttendeesList);
